import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

export default function ContactMe() {
  const form = useRef();
  const [formSubmitted, setFormSubmitted] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_e5rqzhs", "template_qun44lk", form.current, {
        publicKey: "hp-UXE0kAYBed56qe",
      })
      .then(
        () => {
          console.log("SUCCESS!");
          setFormSubmitted(true);
        },
        (error) => {
          console.log("FAILED...", error.text);
        }
      );
  };

  return (
    <section id="Contact" className="contact--section">
      <div>
        <p className="sub--title">Get In Touch</p>
        <h2>Contact Me</h2>
        <p className="text-lg">
          Feel free to reach out to me through my personal website portfolio for
          any inquiries or collaborations.
        </p>
      </div>
      {!formSubmitted && (
        <form
          ref={form}
          onSubmit={sendEmail}
          className="contact--form--container"
        >
          <div className="container">
            <label htmlFor="first-name" className="contact--label">
              <span className="text-md">First Name</span>
              <input
                type="text"
                className="contact--input text-md"
                name="first_name"
                id="first_name"
                required
              />
            </label>
            <label htmlFor="last-name" className="contact--label">
              <span className="text-md">Last Name</span>
              <input
                type="text"
                className="contact--input text-md"
                name="last_name"
                id="last_name"
                required
              />
            </label>
            <label htmlFor="email" className="contact--label">
              <span className="text-md">Email</span>
              <input
                type="email"
                className="contact--input text-md"
                name="user_email"
                id="email"
                required
              />
            </label>
            <label htmlFor="phone-number" className="contact--label">
              <span className="text-md">Phone Number</span>
              <input
                type="tel"
                className="contact--input text-md"
                name="phone_number"
                id="phone_number"
                required
              />
            </label>
          </div>
          <label htmlFor="choose-topic" className="contact--label">
            <span className="text-md">Choose a topic</span>
            <select name="select" id="topic" className="contact--input text-md">
              <option>Select One...</option>
              <option value="Collaborations">Collaborations</option>
              <option value="Inquiries">Inquiries</option>
              <option value="Partnership Opportunities">
                Partnership Opportunities
              </option>
            </select>
          </label>
          <label htmlFor="message" className="contact--label">
            <span className="text-md">Message</span>
            <textarea
              className="contact--input text-md"
              id="message"
              rows="8"
              placeholder="Type your message..."
              name="message"
            />
          </label>
          <div>
            <button className="btn btn-primary contact--form--btn">
              Submit
            </button>
          </div>
        </form>
      )}
      {formSubmitted && (
        <p className="text-lg">
          <img
            className="form-submitted-sucess-btn"
            src="./img/checked.png"
            alt="Form Submitted Sucess"
            // className="icon"
          />
          Thank you for getting in touch! We will get back to you soon.
        </p>
      )}
    </section>
  );
}
